/**
* cta banner two JS
* -----------------------------------------------------------------------------
*
* All the JS for the cta banner two component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import lottie from 'lottie-web';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'cta-banner-two',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      const anim = lottie.loadAnimation( {
        container: document.querySelector( '#lottie-player' ),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        style: 'width: 100vw',
        path: '/wp-content/themes/brown-and-burger/components/cta-banner-two/cta-banner-lottie/yellow-lottie.json',
      } );

      ScrollTrigger.create( {
        trigger: '.cta-banner-two',
        start: 'top 25%',
        // endTrigger: "#otherID",
        end: '+=5000',
        // markers: true,
        // end:"bottom bottom",
        // pin: true,
        // onToggle: ( self ) => console.log( 'toggled, isActive:', self.isActive ),
        onEnter: ( progress, direction, isActive ) => {
          // console.log("progress:", self.progress.toFixed(3), "direction:", self.direction, "velocity", self.getVelocity());
          anim.play();
        //   // console.log(self.progress);
        //   // console.log(anim.totalFrames);
        //   // console.log( anim.currentFrame );
        },
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cta-banner-two', COMPONENT );
} )( app );
